/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Privacylist_Apikey2Inputs */

const id_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API Anda disimpan dengan aman di cookie browser`)
};

const ms_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API anda disimpan dengan selamat dalam kuki penyemak imbas`)
};

const da_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din API-nøgle opbevares sikkert i browser-cookies`)
};

const de_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr API-Schlüssel wird sicher in Browser-Cookies gespeichert`)
};

const en_us2_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your API key is stored securely in browser cookies`)
};

const es_es2_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu clave de API se almacena de forma segura en las cookies del navegador`)
};

const es_mx2_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu clave de API se almacena de forma segura en las cookies del navegador`)
};

const fil_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang iyong API key ay ligtas na nakaimbak sa browser cookies`)
};

const fr_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre clé API est stockée de manière sécurisée dans les cookies du navigateur`)
};

const it_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua chiave API è memorizzata in modo sicuro nei cookie del browser`)
};

const hu_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcsod biztonságosan a böngésző sütikben tárolódik`)
};

const nl_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je API-sleutel wordt veilig opgeslagen in browsercookies`)
};

const no_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkelen din lagres sikkert i nettleserinformasjonskapsler`)
};

const pl_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój klucz API jest bezpiecznie przechowywany w ciasteczkach przeglądarki`)
};

const pt_br2_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua chave API é armazenada com segurança nos cookies do navegador`)
};

const pt_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua chave de API é armazenada de forma segura nos cookies do navegador`)
};

const ro_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheia ta API este stocată în siguranță în cookie-urile browserului`)
};

const fi_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avaimesi tallennetaan turvallisesti selaimesi evästeisiin`)
};

const sv_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din API-nyckel lagras säkert i webbläsarens cookies`)
};

const vi_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khóa API của bạn được lưu trữ an toàn trong cookie trình duyệt`)
};

const tr_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarınız tarayıcı çerezlerinde güvenle saklanır`)
};

const cs_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Váš API klíč je bezpečně uložen v cookies prohlížeče`)
};

const bg_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашият API ключ се съхранява сигурно в бисквитките на браузъра`)
};

const ru_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш API-ключ хранится в файлах cookie браузера`)
};

const uk_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш API-ключ безпечно зберігається в файлах cookie браузера`)
};

const ar_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم تخزين مفتاح API الخاص بك بشكل آمن في ملفات تعريف الارتباط للمتصفح`)
};

const hi_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी API कुंजी ब्राउज़र कुकीज़ में सुरक्षित रूप से संग्रहीत की जाती है`)
};

const th_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คีย์ API ของคุณถูกจัดเก็บอย่างปลอดภัยในคุกกี้ของเบราว์เซอร์`)
};

const ja_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーはブラウザの Cookie に安全に保存されます`)
};

const zh_cn2_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的API密钥安全存储在浏览器Cookie中`)
};

const zh_hant1_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的API金鑰安全儲存在瀏覽器Cookie中`)
};

const ko_notifications_privacylist_apikey2 = /** @type {(inputs: Notifications_Privacylist_Apikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 키는 브라우저 쿠키에 안전하게 저장됩니다`)
};

/**
* | output |
* | --- |
* | "Your API key is stored securely in browser cookies" |
*
* @param {Notifications_Privacylist_Apikey2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_privacylist_apikey2 = /** @type {((inputs?: Notifications_Privacylist_Apikey2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Privacylist_Apikey2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_privacylist_apikey2(inputs)
	if (locale === "ms") return ms_notifications_privacylist_apikey2(inputs)
	if (locale === "da") return da_notifications_privacylist_apikey2(inputs)
	if (locale === "de") return de_notifications_privacylist_apikey2(inputs)
	if (locale === "en-US") return en_us2_notifications_privacylist_apikey2(inputs)
	if (locale === "es-ES") return es_es2_notifications_privacylist_apikey2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_privacylist_apikey2(inputs)
	if (locale === "fil") return fil_notifications_privacylist_apikey2(inputs)
	if (locale === "fr") return fr_notifications_privacylist_apikey2(inputs)
	if (locale === "it") return it_notifications_privacylist_apikey2(inputs)
	if (locale === "hu") return hu_notifications_privacylist_apikey2(inputs)
	if (locale === "nl") return nl_notifications_privacylist_apikey2(inputs)
	if (locale === "no") return no_notifications_privacylist_apikey2(inputs)
	if (locale === "pl") return pl_notifications_privacylist_apikey2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_privacylist_apikey2(inputs)
	if (locale === "pt") return pt_notifications_privacylist_apikey2(inputs)
	if (locale === "ro") return ro_notifications_privacylist_apikey2(inputs)
	if (locale === "fi") return fi_notifications_privacylist_apikey2(inputs)
	if (locale === "sv") return sv_notifications_privacylist_apikey2(inputs)
	if (locale === "vi") return vi_notifications_privacylist_apikey2(inputs)
	if (locale === "tr") return tr_notifications_privacylist_apikey2(inputs)
	if (locale === "cs") return cs_notifications_privacylist_apikey2(inputs)
	if (locale === "bg") return bg_notifications_privacylist_apikey2(inputs)
	if (locale === "ru") return ru_notifications_privacylist_apikey2(inputs)
	if (locale === "uk") return uk_notifications_privacylist_apikey2(inputs)
	if (locale === "ar") return ar_notifications_privacylist_apikey2(inputs)
	if (locale === "hi") return hi_notifications_privacylist_apikey2(inputs)
	if (locale === "th") return th_notifications_privacylist_apikey2(inputs)
	if (locale === "ja") return ja_notifications_privacylist_apikey2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_privacylist_apikey2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_privacylist_apikey2(inputs)
	return ko_notifications_privacylist_apikey2(inputs)
});
export { notifications_privacylist_apikey2 as "notifications.privacyList.apiKey" }